export default __webpack_public_path__ + "static/media/bg1.1034f2f5.png";